const FORMAT_REGEX = /[-\s]/g;
// const THREE_DIGITS_IN_ROW_REGEX = /(\d)\1{2}/;

/**
 * Извлекает только цифры из строки СНИЛС
 */
export function getDigitsOnly(snils: string | null): string | null {
  return snils ? snils.replace(FORMAT_REGEX, "") : null;
}

/**
 * Проверяет контрольную сумму СНИЛС
 * Алгоритм: сумма произведений первых 9 цифр на веса (9..1),
 * результат mod 101, если >= 100 → 0, сравниваем с последними 2 цифрами
 */
export function validateControlSum(snils: string): boolean {
  const numberPart = snils.slice(0, 9);
  const checkDigits = snils.slice(9);

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(numberPart[i], 10) * (9 - i);
  }

  let checkNumber = sum % 101;
  if (checkNumber >= 100) {
    checkNumber = 0;
  }

  return checkNumber === parseInt(checkDigits, 10);
}

/**
 * Основная валидация СНИЛС
 * @returns {string | null} Сообщение об ошибке или null, если валидно
 * @description Пустое значение считается валидным (для опциональных полей)
 */
export function validateSnils(snils: string): string | null {
  const formattedSnils = getDigitsOnly(snils);

  // Пустое значение — валидно (если поле необязательное)
  if (!formattedSnils || formattedSnils.trim() === "") {
    return null;
  }

  if (formattedSnils.length !== 11) {
    return "СНИЛС должен содержать 11 цифр";
  }

  if (formattedSnils.split("").every((c) => c === "0")) {
    return "Некорректный СНИЛС";
  }

  // if (THREE_DIGITS_IN_ROW_REGEX.test(formattedSnils.slice(0, 9))) {
  //   return "СНИЛС не может содержать три одинаковые цифры подряд";
  // }

  if (!validateControlSum(formattedSnils)) {
    return "Неверная контрольная сумма СНИЛС";
  }

  return null;
}

/**
 * Форматирует СНИЛС в стандартный вид: XXX-XXX-XXX XX
 */
export function formatSnils(snils: string): string {
  const digits = getDigitsOnly(snils);
  if (!digits || digits.length !== 11) {
    return snils;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 9)} ${digits.slice(9, 11)}`;
}

/**
 * Убирает форматирование, оставляет только цифры
 */
export function unformatSnils(snils: string): string {
  return getDigitsOnly(snils) || "";
}
